<div class="broker-information-container">
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <form #brokerInfoForm="ngForm" class="broker-info-form">
    <div class="section-header mb-3">
      <h5>Broker/Loan Officer Information</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">TPO Company NMLS Number</label>
        <text-input
          [(ngModel)]="formData.tpoCompanyNmlsNumber"
          name="tpoCompanyNmlsNumber"
          [readonly]="true">
        </text-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Processor Name</label>
        <text-input
          [(ngModel)]="formData.processorName"
          name="processorName"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Processor Email</label>
        <text-input
          [(ngModel)]="formData.processorEmail"
          name="processorEmail"
          [readonly]="true">
        </text-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">LO Name</label>
        <text-input
          [(ngModel)]="formData.loName"
          name="loName"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">LO Email</label>
        <text-input
          [(ngModel)]="formData.loEmail"
          name="loEmail"
          [readonly]="true">
        </text-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>eSign and Closing</h5>
    </div>
    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Will Snap Docs be used?</label>
        <select
          class="form-select"
          [(ngModel)]="formData.willSnapDocsBeUsed"
          name="willSnapDocsBeUsed">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
        <small class="text-info d-block mt-1">
          <i class="fa-solid fa-info-circle"></i>
          If using Snap Docs, confirm that the Settlement Company has also agreed.
        </small>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Is this a hybrid closing?</label>
        <select
          class="form-select"
          [(ngModel)]="formData.isHybridClosing"
          name="isHybridClosing">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>
    </div>

  </form>
</div>
